import React from 'react'

export const illinoisSetupVars = {
  siteId: 'illinois',
  pathPrefix: '/il',
  menuHeader: "Discover Illinois's Solution for:",
  appUrl: 'https://il.headed2.com',
  logoImg: '/images/assets/illinois/horizontal/dark.svg',
  headerTitle: `The Illinois CareerExplorer is a system designed for Illinois`
}
